module.exports = __webpack_public_path__ + "static/media/italy.415ea5cf.svg";